import { FC } from 'react';
import { Country } from 'react-easyrocket';
import { SpriteFlagDisplay } from '../../../SpriteFlagDisplay';
import { IconName } from '../../../SpriteFlagDisplay/sprite/icon-types';

interface DropdownItemProps {
  country: Country;
  onSelectCountry: (country: Country) => void;
}

export const DropdownItem: FC<DropdownItemProps> = ({ country, onSelectCountry }) => {
  const handleSelectCountry = () => {
    onSelectCountry(country);
  };

  return (
    <li
      onClick={handleSelectCountry}
      className={
        'flex items-center f32 gap-2 p-2 cursor-pointer hover:bg-gray-100 hover:bg-input-border'
      }>
      <div>
        <SpriteFlagDisplay flag={country?.alpha2 as IconName} />
      </div>
      <span>{country?.name}</span>
      <span className="ml-auto text-gray-500">{country?.phoneCodes[0]}</span>
    </li>
  );
};
